import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import HeaderCustom from "../../../components/HeaderCustom";
import SkeletonLoading from "../../../components/SkeletonLoading";
import { getDetalleCategoria, postAddCategoria, postUpdateCategoria } from "../../../api/ApiService";
// import "../../../styles/AppCss.css";

function AddCategoriaPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const { id } = useParams();
    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleCategoria();
            }
            return;
        }

        const timeoutId = setTimeout(() => {
            setCargando(true);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [id, stateToken]);

    const handleDetalleCategoria = () => {
        getDetalleCategoria(id, stateToken?.access_token)
            .then((response) => {
                setCargando(true);
                setTitulo(response?.data?.nombre || "");
            })
            .catch(() => {
                setCargando(true);
                setMensaje("Error al cargar los datos");
                setSeverity("error");
                setOpen(true);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        window.history.back();
    };

    const handleGuardar = () => {
        const body = {
            nombre: titulo,
        };

        if (titulo.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("Todos los campos son obligatorios");
            return;
        }

        setLoadingGuardar(true);
        handleAddCategoriaApi(body);
    };

    const handleAddCategoriaApi = (body) => {
        postAddCategoria(body, stateToken?.access_token)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Guardado con exito");
                setTitulo("");

                setTimeout(() => {
                    navigate('/app/admin/locales-categorias');
                }, 1500);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar la categoria");

                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    const handleGuardarUpdate = () => {
        const body = {
            nombre: titulo,
        };

        if (titulo.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("Todos los campos son obligatorios");
            return;
        }

        setLoadingGuardar(true);
        handleUpdateCategoriaApi(body);
    };

    const handleUpdateCategoriaApi = (body) => {
        postUpdateCategoria(id, body, stateToken?.access_token)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Guardado con exito");

                setTimeout(() => {
                    navigate('/app/admin/locales-categorias');
                }, 1500);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar la categoria");

                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    const alertStyles = {
        success: "border-emerald-200 bg-emerald-50 text-emerald-700",
        error: "border-red-200 bg-red-50 text-red-700",
        warning: "border-amber-200 bg-amber-50 text-amber-700",
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-4xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">
                            {id ? "Editar Categoria" : "Crear Categoria"}
                        </h1>
                        <p className="text-sm text-gray-500">
                            Completa la informacion principal de la categoria y guarda los cambios.
                        </p>
                    </div>

                    {cargando ? (
                        <div className="overflow-hidden rounded-xl bg-white p-6 shadow-xl sm:p-8">
                            <div className="space-y-6">
                                <div>
                                    <label className="mb-2 block text-sm font-semibold text-gray-800">
                                        Nombre de la Categoria
                                    </label>
                                    <input
                                        type="text"
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                        autoCapitalize="none"
                                        autoCorrect="off"
                                        placeholder="Ingrese el nombre de la categoria"
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>

                                <div className="mt-6 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-6">
                                    <button
                                        type="button"
                                        onClick={() => (id ? handleGuardarUpdate() : handleGuardar())}
                                        disabled={loadingGuardar}
                                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553] disabled:cursor-not-allowed disabled:opacity-70"
                                    >
                                        {loadingGuardar ? "Guardando..." : "Guardar"}
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        disabled={loadingGuardar}
                                        className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-70"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {loadingGuardar && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/35 backdrop-blur-sm">
                    <div className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 shadow-xl">
                        <div className="h-5 w-5 animate-spin rounded-full border-2 border-[#104063] border-t-transparent" />
                        <p className="text-sm font-medium text-gray-700">Guardando categoria...</p>
                    </div>
                </div>
            )}

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div className={`rounded-xl border px-4 py-3 shadow-lg ${alertStyles[severity] || alertStyles.error}`}>
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </HeaderCustom>
    );
}

export default AddCategoriaPage;
